import Vue from 'vue';
import SearchBar from './components/SearchBar.vue';

const searchBars = Array.from(document.querySelectorAll('.vue-search-autocomplete'));

searchBars.forEach((searchBar) => {
    const urlQuery = searchBar.dataset.query;

    new Vue({
        el: searchBar,
        render: (h) => {
            return h(SearchBar, {
                props: {
                    urlQuery
                }
            });
        }
    });
});
